import { useQuery } from "@tanstack/react-query";
import { MarketingService, type MarketingReferral } from "@/lib/api_client";
import { fetchAll } from "./fetchAll";

/**
 * Every marketing referral. The one caller (the CRM page) narrows to the
 * selected period client-side, in `groupedReferrals`.
 *
 * The dropped `{ from, to }` range sent `filter[createdAt][gte]`, a syntax the
 * API never understood and now rejects. No caller passed it, so it filtered
 * nothing; moving the window server-side needs the dashboard to show a loading
 * state on period change, which is a change to make on purpose.
 */
export const useMarketingReferrals = (enabled = true) =>
  useQuery({
    queryKey: ["marketing-referrals"],
    queryFn: () =>
      fetchAll<MarketingReferral>((opts) =>
        MarketingService.getApiMarketingReferrals(opts),
      ),
    staleTime: 5 * 60_000,
    enabled,
  });
